import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export type AndamentoCotaUsuario = {
  id: number;
  origem: string;
  origemId?: number;
  tipo: string;
  visibilidade?: string;
  descricao: string;
  observacoes?: string;
  metadata?: Record<string, any>;
  created_at?: string;
  criadoPorTipo?: string | null;
  criadoPorId?: number | null;
  criadoPor?: {
    tipo?: string;
    id?: number;
    nome?: string;
    email?: string;
    em?: string;
  };
};

export const buscarAndamentosCotaUsuarioService = async (
  cotaUsuarioId: number
): Promise<AndamentoCotaUsuario[]> => {
  if (!cotaUsuarioId || cotaUsuarioId <= 0) {
    return [];
  }

  const token = validateToken();
  const url = `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioId}/andamentos`;

  try {
    const response = await axios.get(url, {
      headers: token ? { Authorization: token.AuthStr } : undefined,
    });

    let data = response?.data;

    if (data && typeof data === "object" && !Array.isArray(data)) {
      data = data.andamentos || data.data || data.resultado || [];
    }

    if (!Array.isArray(data)) {
      return [];
    }

    return (data as AndamentoCotaUsuario[])
      .filter((item) => {
        if (!item || !item.id) {
          return false;
        }

        const origemId = Number(
          item.origemId ?? item.metadata?.cotaUsuarioId ?? cotaUsuarioId
        );

        return origemId === cotaUsuarioId;
      })
      .sort((a, b) => {
        const dataA = new Date(a.criadoPor?.em || a.created_at || 0).getTime();
        const dataB = new Date(b.criadoPor?.em || b.created_at || 0).getTime();
        return dataB - dataA;
      });
  } catch (error) {
    console.error("Erro ao buscar andamentos da cota do usuario:", error);
    return [];
  }
};
